import { ActivityCode, ActivityName, ActivityRepository, ActivityQuery, Activity } from '@/Domain/Activities'
import { LanguageCode } from '@/Domain/Localization'

const storedActivities: { [key: string]: Activity[] } = {
  es: [
    new Activity(new ActivityCode('0618.1'), new ActivityName('Ingeniería')),
    new Activity(new ActivityCode('0618.2'), new ActivityName('Mecánica')),
    new Activity(new ActivityCode('0618.3'), new ActivityName('Electrónica')),
    new Activity(new ActivityCode('0618.4'), new ActivityName('Maderera')),
    new Activity(new ActivityCode('0618.5'), new ActivityName('Pesca')),
    new Activity(new ActivityCode('0618.6'), new ActivityName('Ganadería'))
  ],
  gl: [
    new Activity(new ActivityCode('0618.1'), new ActivityName('Enxeñería')),
    new Activity(new ActivityCode('0618.2'), new ActivityName('Electrónica')),
    new Activity(new ActivityCode('0618.3'), new ActivityName('Madereira')),
    new Activity(new ActivityCode('0618.4'), new ActivityName('Pesca')),
    new Activity(new ActivityCode('0618.5'), new ActivityName('Gandería'))
  ]
}
async function wait (ms: number) {
  return new Promise(resolve => {
    setTimeout(resolve, ms)
  })
}
export class InMemoryActivitiesRepository implements ActivityRepository {
  async byQuery (languageCode: LanguageCode, query: ActivityQuery): Promise<Activity[]> {
    await wait(400)
    const language = languageCode as string
    const parsedQuery = query.value().toLocaleLowerCase('es-ES')
      .replace('a', '(a|á)')
      .replace('e', '(e|é)')
      .replace('i', '(i|í)')
      .replace('o', '(o|ó)')
      .replace('u', '(u|ú)')
    const regex = new RegExp(parsedQuery, 'i')
    const items = storedActivities[language] || []
    const found = items.filter(current => {
      const inName = regex.test(current.name())
      const inCode = regex.test(current.code())
      return inName || inCode
    })
    return Promise.resolve(found)
  }
}
